<template>
  <div class="card">
        <my-header v-if="platform.indexOf('mymissionios')>-1" title="星座集卡" :platform="platform.replace('mymission','')"></my-header>
      <div class="back-pre" v-if="backIs" @click="goBack">&lt; 上一页</div>
      <img class="card-title" src="/static/card/card-title.png" alt="">
      <img class="activity-desc" :style="platform.indexOf('mymissionios')>-1?'top:65px':''" @click="activityIs = true" src="/static/card/activity-desc.png" alt="">
      

      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(card,index) in cardList" :key="index">
            <div class="card-item">
              <div class="card-img" @click="getCardInfo(item)" v-for="(item,index1) in card" :key="index1">
                <img :src="item.cardImgUrl" alt="">
                <img v-if="item.isLock==1&&item.isSee==0" class="new-icon" src="/static/card/card-new-icon.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"> </div>
      </div>

      <div @click="unlockMore" class="card-btn">推课解锁更多星座卡</div>
      <!-- 卡片弹框开始 -->
      <van-overlay :show="cardIs" @click="cardIs = false">
        <div class="card-pop-box" @click.stop>
          <img class="card-close" @click="cardIs = false" src="/static/card/close.png" alt="">
          <div class="swiper-container1">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in cardItemList" :key="index">
                <img class="card-item-title" src="/static/card/card-item-title.png" alt="">
                <div class="card-item-box">
                  <img v-if="item.isLock==1&&swiperIndex==index" class="card-bor" src="/static/card/card-bor.png" alt="">
                  <img class="card-item" :src="item.cardImgUrl" alt="">
                </div>
                <div v-if="item.isLock==1&&swiperIndex==index" class="card-desc">
                  <p style="text-align:center;margin-bottom:10px">{{item.cDesc}}</p>
                  <p style="font-size:12px;font-weight:400;">关键词：<span style="color:#fff">{{item.cKeyword}}</span></p>
                </div>
                <div v-if="item.isLock==0&&swiperIndex==index" class="lockno">
                  <div @click="unlockMore" style="margin-top:0" class="card-btn">推课解锁更多星座卡</div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination1"></div>
          </div>
        </div>
      </van-overlay>
      <!-- 卡片弹框结束 -->
      <!-- 活动说明弹框开始 -->
      <van-overlay :show="activityIs" @click="activityIs = false">
        <div class="activity-pop-box" @click.stop>
          <div class="activity-pop">
            1、参与活动，填写生日，即可解锁1张专属考拉星座卡;<br>
            2、解锁剩余11张星座卡，只需您邀请家有海外4-12岁少儿的亲友注册试听，每有一位好友完成试听，就将解锁1张新卡片;<br>
            3、集齐全部12张卡片后，您还将一次性获得2000桉树叶！快来行动吧！
            <!-- 1、参与活动，即可解锁一张专属生日卡;<br>
            2、剩余11张星座卡解锁，需要您邀请好友加入考拉知道。每有一位好友完成试听课体验，将解锁一张卡片;<br>
            3、解锁全部12张卡片后，您还将一次性获得2000桉树叶！快来行动吧！ -->
          </div>
          <img class="close" @click="activityIs = false" src="/static/card/close.png" alt="">
        </div>
      </van-overlay>
      <!-- 活动说明弹框结束 -->
      <!-- 获得新卡牌弹框开始 -->
      <van-overlay :show="newCardIs" @click="newCardIs = false">
        <div class="new-card-pop" @click.stop>
          <div class="card-mess">
            <img :src="giveCardInfo.cSymbol" alt="">
            <div class="card-mess-right">
              <p class="card-name">{{giveCardInfo.cName}}</p>
              <p class="name">{{giveCardInfo.cNameEn}}</p>
              <p class="card-time">{{giveCardInfo.cTime}}</p>
            </div>
          </div>
          <p class="new-card-msg">欢迎到来，我们匹配到您的生日<br>为您解锁一张专属考拉星座卡</p>
          <p class="new-card-rule">每邀请一位4-12岁海外华裔少儿注册并体验课程，就能解锁一张考拉星座卡。集齐12张星座卡，除常规奖励外，还能额外再一次性获得
            <span style="color:#FFEB65">2000桉树叶</span>！快快去分享海报完成邀请吧！
          </p>
          <div class="card-btn" @click="getBirthdayCard">知道了</div>
          <!-- <div @click="changeBirthday" class="birthday-change">我的生日写错了，去修改 ></div> -->
        </div>
      </van-overlay>
      <!-- 获得新卡牌弹框结束 -->
      <!-- 获得新卡牌提醒弹框开始 -->
      <van-overlay :show="remindIs" @click="remindIs = false">
        <div class="remind-pop" @click.stop>
          <p class="remind-msg">新获得{{noSeeCardCount}}张星座卡</p>
          <div class="remind-btn" @click="remindConfirm">知道了</div>
        </div>
      </van-overlay>
      <!-- 获得新卡牌提醒弹框结束 -->
      <!-- 获得全部卡牌弹框开始 -->
      <van-overlay :show="bothIs" @click="bothIs = false">
        <div class="both-pop" @click.stop>
          <p class="both-msg">您集齐全部星座卡，真是太棒了！<br>您获得了2000桉树叶！</p>
          <div class="both-btn" @click="bothIs = false">立即领取</div>
        </div>
      </van-overlay>
      <!-- 获得全部卡牌弹框结束 -->
      <!-- 填写生日开始 -->
      <van-overlay :show="birthdayIs">
        <div class="birthday-pop" @click.stop>
          <h5>选择生日</h5>
          <input @click="selectCanendar" v-model="birthday" readonly placeholder="请选择生日" type="text">
          <p v-if="birthday" class="birthday-error">您将免费获得一张与您生日对应的星座卡，但生日将无法再次修改，是否确认？</p>
          <div class="birthday-btns">
            <button @click="addShengRi">确定</button>
            <!-- <button class="cancel" @click="birthdayIs = false">取消</button> -->
          </div>
        </div>
        <div class="date-select" v-if="dataIs" @click.stop>
          <van-datetime-picker
            type="date"
            :value="new Date()"
            :min-date="new Date('1990/01/01 00:00:00')"
            :max-date="new Date()"
            @confirm="confirmData"
            @cancel="dataIs=false"

          />
        </div>
      </van-overlay>
      <!-- 填写生日结束 -->
  </div>
</template>

<script>
import Swiper from 'swiper';
import "swiper/css/swiper.min.css"
import { Overlay,Toast,DatetimePicker } from 'vant';
import http from "../../../service/http"
import MyHeader from "../common/MyHeader/MyHeader"
export default {
  components: {
    [Overlay.name]:Overlay,
    [DatetimePicker.name]: DatetimePicker,
    MyHeader
  },
  data(){
    return {
      cardIs:false,//卡片弹框显示
      activityIs:false,//活动弹框显示
      newCardIs:false,//获得新卡牌显示
      remindIs:false,//获得新卡牌提醒显示
      bothIs:false,//获得全部卡牌显示
      birthdayIs:false,//填写生日弹框
      btnIs:false,//按钮重复点击
      birthday:"",
      dataIs:false,//日期选择
      cardSwiper:null,
      guid:"",
      uid:"",
      // 列表
      cardList:[],
      cardItemList:[],
      noSeeCardCount:0,//未读卡片数量
      giveCardInfo:{},//生日赠送卡片
      swiperIndex:0,
      backIs: false,
      platform:''
    }
  },
  created(){
    document.title='星座集卡'
    this.guid=this.$route.query.guid
    this.uid=this.$route.query.uid||''
    this.getNoSeeCard()
    this.getCardList()
    
  },
  mounted() {
    this.platform=this.$route.query.platform||''
    
    if(this.platform=='ios'){
      this.backIs=true
      // console.log(document.title)
      window.webkit.messageHandlers.ClickTitleText.postMessage('星座集卡');
    }
    
  },
  methods:{
    unlockMore(){
      let url=`https://www.koalaknow.com/Vchar/IntroduceCover?uid=${this.uid}&wxCover=1&oaid=0&guid=${this.guid}`
      if(this.$route.query.platform=='ios'){
        url=url+'&platform=ios'
      }
      window.location.href=url
    },
    showCategory(res){
      switch (res.showCategory) {
        case 'enyNoShow'://不显示任何弹框
            
            break;
        case 'enyAddShengRi'://显示填写生日弹窗
            this.birthdayIs=true
            break;
        case 'enyGiveShengRi'://显示赠送生日卡片弹窗
            this.giveCardInfo=res.giveCardInfo||{}//卡片详情
            this.newCardIs=true
            break;
        case 'enyNoSeeCard'://显示未读取数量弹窗
            this.remindIs=true
            break;
        case 'enyWanCheng'://显示收集完成弹窗
            this.bothIs=true
            break;
        default:
            break;
      }
    },
    // 查看卡片
    getCardInfo(item){
      let that=this
      this.cardIs=true
      this.lookCardInfo(item)
      this.$nextTick(()=>{
        if(!this.cardSwiper){
          this.cardSwiper=new Swiper('.swiper-container1', {
            // width:750,
            // height:1336,
            speed: 700,
            slidesPerView: 'auto',
            centeredSlides: true,
            watchSlidesProgress: true,
            pagination: {
              el: '.swiper-pagination1',
              clickable :true,
            },
            on:{
              slideChangeTransitionEnd:function(){
                that.swiperIndex=this.activeIndex
                console.log(this.activeIndex)
                that.lookCardInfo(that.cardItemList[this.activeIndex])
              }
            }
          })
        }
        let index=this.cardItemList.findIndex(i=>i.constellationId==item.constellationId)||0
        that.swiperIndex=index
        this.cardSwiper.slideTo(index,700,false)
      })
    },
    lookCardInfo(item){
      let data={
        cmd: 'GetUserConstellationCardInfo',
        userGuid: this.guid,
        constellationId:item.constellationId
      }
      let index=this.cardItemList.findIndex(i=>i.constellationId==item.constellationId)
      http.req(data,(res)=>{
          if(res.flag==1){
              if(this.cardItemList[index].isSee!=1){
                this.cardItemList[index].isSee=1
                let newArr = [];
                for (var i = 0; i < this.cardItemList.length; i += 4) {
                    newArr.push(this.cardItemList.slice(i, i + 4));
                }
                this.cardList=newArr
              }
          }else{
              Toast.msg(res.msg)
          }
      })
    },
    // 填写生日
    addShengRi(){
      if(!this.birthday){
        Toast('请选择生日')
        return false
      }
      if(this.btnIs){
        return false
      }
      this.btnIs=true
      let data={
        cmd: 'UpdateUserBrithdayGiveCard',
        userGuid: this.guid,
        userBrithday:this.birthday
      }
      http.req(data,(res)=>{
          this.btnIs=false
          if(res.flag==1){
              // this.giveCardInfo=res.giveCardInfo||{}
              this.birthdayIs=false
              this.showCategory(res)
              this.getCardList()
          }else{
              Toast.msg(res.msg)
          }
      })
    },
    // 生日赠送卡片我知道了
    getBirthdayCard(){
      this.newCardIs=false
      
    },
    // 修改生日
    changeBirthday(){
      this.newCardIs=false
      this.birthdayIs=true
    },
    // 获得生日卡片
    remindConfirm(){
      this.remindIs=false
      this.getCardList()
    },
    selectCanendar(){
      this.dataIs=true
    },
    confirmData(e){
      this.birthday=this.timeFormat(e.getTime()/1000,'yyyy-MM-dd')
      this.dataIs=false
    },
    //检查用户是否存在未显示卡片
    getNoSeeCard(){
        let data={
            cmd: 'CheckUserConstellationNoSeeCard',
            userGuid: this.guid,
        }
        http.req(data,(res)=>{
            if(res.flag==1){
                this.noSeeCardCount=res.noSeeCardCount
                this.showCategory(res)
            }else{
                Toast.msg(res.msg)
            }
        })
    },
    // 获取卡片列表
    getCardList(){
        let data={
            cmd: 'GetUserConstellationCardList',
            userGuid: this.guid,
        }
        http.req(data,(res)=>{
            if(res.flag==1){
                console.log('res',res)
                let newArr = [];
                for (var i = 0; i < res.list.length; i += 4) {
                    newArr.push(res.list.slice(i, i + 4));
                }
                this.cardList=newArr
                this.cardItemList=res.list
                this.$nextTick(()=>{
                  this.getSwiper()
                })
            }else{
                Toast.msg(res.msg)
            }
        })
    },
    getSwiper(){
      new Swiper('.swiper-container', {
        autoplay: false,//可选选项，自动滑动
        speed: 700,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable :true,
        },
      })
      
    },
    goBack(){
      this.$router.back(-1)
    },
    timeFormat : (value, format) => {
        if (value == 0 || value == '') {
            return ''
        }
        value = Number(value)
        if (isNaN(value)) {
            return ''
        }
        var value1 = value.length > 10 ? value : value * 1000
        var d = new Date(value1)
        var year = d.getFullYear() < 10 ? '0' + d.getFullYear() : d.getFullYear()
        var month = d.getMonth() + 1 < 10 ? '0' + Number(d.getMonth() + 1) : Number(d.getMonth() + 1)
        var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
        var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
        var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
        var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
        let data = {
            yyyy: year,
            MM: month,
            dd: day,
            hh: hour,
            mm: minutes,
            ss: seconds,
        }
        let str = format
        for (let key in data) {
            str = str.replace(key, data[key])
        }
        return str
    }
  }
}
</script>

<style scoped>
.card{
    min-height: 100vh;
    background: url('/static/card/card-bg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    padding-top: 50px;
    box-sizing: border-box;
}
.card-title{
  width: 450px;
  height: 117px;
  display: block;
  margin: 0 auto;
  margin-bottom: 40px;
}
.activity-desc{
  width: 92px;
  position: absolute;
  top: 32px;
  right: 19px;
}

.card-btn{
  width: 460px;
  height: 80px;
  background: url('/static/card/card-btn.png') no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  line-height: 80px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #32150A;
  text-align: center;
  margin-top: 30px;
}
.card-item{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 20px;
}
.card-img{
  width: 231px;
  height: 390px;
  margin-right: 50px;
  margin-bottom: 28px;
  position: relative;
}

.card-img:nth-child(2n){
  margin-right:0;
}
.card-img img{
  width: 100%;
  height: 100%;
}
.card-img .new-icon{
  position: absolute;
  top: 30px;
  right: -30px;
  width: 90px;
  height: 37px;
}


.swiper-slide {
  margin-left: 30px;
	padding: 0;
	width: 100%;
	margin: 0 0;
  opacity: 0.8;
}
.swiper-slide-active {
	opacity: 1;
}
.swiper-container .swiper-slide{
  width: 570px;
}
.swiper-container1 .swiper-slide{
  width: 590px;
  opacity: 1;
  transform: scale(0.98);
}
.swiper-container1 .swiper-slide-active{
  transform: scale(1);
}


/deep/ .swiper-container-horizontal>.swiper-pagination-bullets{
  bottom: 0;
}
/deep/ .swiper-pagination-bullet{
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.4);
}
/deep/ .swiper-pagination-bullet-active{
  width: 24px;
  background: #fff;
}
.swiper-pagination1{
  text-align: center;
}
/* 添加生日弹框开始 */
.birthday-pop{
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  /* height: 200px; */
  background-color: #fff;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 0 30px;
  padding-bottom: 30px;
}
.birthday-error{
  font-size: 24px;
  color: red;
  margin-bottom: 30px;
}
.birthday-pop h5{
  padding: 20px 0;
  text-align: center;
  font-size: 30px;
}
.birthday-pop input{
  height: 70px;
  border: 1px solid #ccc;
  border-radius: 70px;
  font-size: 28px;
  padding-left: 30px;
  width: 440px;
  box-sizing: border-box;
  margin-bottom: 20px;
  margin-top: 30px;
}

.birthday-btns{
  display: flex;
  justify-content: center;
}
.birthday-btns button{
  width: 200px;
  height: 70px;
  border-radius: 70px;
  border: none;
  outline: none;
  background: red;
  color: #fff;
  box-sizing: border-box;
}
.birthday-btns button.cancel{
  border: 1px solid #ccc;
  color: #333;
  background: #fff;
}
.date-select{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
/* 添加生日弹框结束 */
/* 卡牌弹框开始 */
.card-close{
  width: 72px;
  height: 72px;
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 100;
}
.card-item-title{
  width: 465px;
  height: 104px;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
}
.card-item-box{
  width: 457px;
  height: 774px;
  position: relative;
  margin: 0 auto;
}
.card-bor{
  width: 682px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.card-item-box .card-item{
  width: 100%;
  height: 100%;
}
.card-desc{
  width: 100%;
  min-height: 176px;
  box-sizing: border-box;
  background: url('/static/card/card-desc.png') no-repeat;
  background-size: 100% 100%;
  margin: 18px auto;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFE04F;
  padding:33px 62px;
}
.lockno{
  width: 588px;
  height: 176px;
  background: url('/static/card/lockno-bj.png') no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
}
/* 活动说明弹框 */
.activity-pop-box{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.activity-pop{
  width: 570px;
  background:url('/static/card/activity-bj.png') no-repeat ;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 117px 40px;
  padding-bottom: 50px;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 48px;
  text-shadow: 0px 0px 38px rgba(0, 0, 0, 0.7);
}
.close{
  width: 60px;
  height: 60px;
  position: absolute;
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
}
/* 获得新卡牌弹框 */
.new-card-pop{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 650px;
  /* height: 770px; */
  padding-bottom: 50px;
  background:url('/static/card/new-card-bj.png') no-repeat ;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 129px;
}
.card-mess{
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-mess img{
  width: 171px;
  height: 171px;
  margin: 0;
  margin-right: 23px;
}
.card-name{
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 48px;
}
.name{
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 48px;
}
.card-time{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}
.new-card-msg{
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFEB65;
  line-height: 40px;
  text-align: center;
  margin-top: 37px;
}
.new-card-rule{
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  margin-top: 40px;
  padding: 0 40px;
}
.birthday-change{
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFEB65;
  line-height: 60px;
  margin-top: 29px;
  text-align: center;
}
/* 获得新卡牌提醒弹框 */
.remind-pop{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 723px;
  height: 802px;
  padding-bottom: 50px;
  background:url('/static/card/new-card-msg-bj.png') no-repeat ;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 153px;
}
.remind-msg{
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 60px;
  text-align: center;
}
.remind-btn{
  height: 80px;

  text-align: center;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #32150A;
  line-height: 80px;
  margin-top: 380px;
}
/* 获得全部卡片弹框 */
.both-pop{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 750px;
  height: 877px;
  padding-bottom: 50px;
  background:url('/static/card/both-card-bj.png') no-repeat center center;
  background-size: 877px 877px;
  box-sizing: border-box;
  padding-top: 630px;
}
.both-msg{
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
}
.both-btn{
  height: 80px;

  text-align: center;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #32150A;
  line-height: 80px;
  margin-top: 20px;
}

/* vant央视覆盖 */
/deep/ .van-picker__toolbar{
  height: 80px;
}
/deep/ .van-picker__cancel, /deep/ .van-picker__confirm{
  font-size: 28px;
}
/deep/ .van-picker-column__item{
  font-size: 28px;
}

.back-pre{
  position: fixed;
  top: 20px;
  left: 0;
  padding: 40px 30px;
  font-size: 28px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/content/card.vue